// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m-orm-delete-dialog{overflow-y:unset!important}.lh-normal{line-height:normal}", ""]);
// Exports
module.exports = exports;
